<template>
  <page-status class="cert-repair" :loading="loading">
    <van-cell-group>
      <van-cell>
        <cell-header slot="title" title="报案信息" />
      </van-cell>
      <van-cell title="报案号" :value="docDetail.reportNo" />
      <van-cell title="出险时间" :value="docDetail.accTime" />
      <van-cell title="出险地点" :value="docDetail.accAddress" />
      <van-cell title="出险人" :value="docDetail.accUser" />
    </van-cell-group>

    <van-cell-group>
      <van-cell>
        <cell-header slot="title" title="资料上传" />
      </van-cell>
      <div class="item-alert">
        <alert-view v-if="alertConfigNames">
          <span>请提交以下材料：</span>
          <span class="active">{{ alertConfigNames }}</span>
        </alert-view>
      </div>
      <cert-image-picker
        v-for="(val, index) in docDetail.docConfigs"
        :key="index"
        :config="val"
        :confirm="onUpdateImage"
      />
    </van-cell-group>

    <div class="operate">
      <van-button
        type="info"
        block
        :disabled="submiting"
        :loading="submiting"
        loading-text="提交中..."
        @click="onSubmit"
      >
        提交资料
      </van-button>
    </div>
  </page-status>
</template>

<script>
import { Toast } from 'vant';
import PageStatus from '@/components/PageStatus';
import AlertView from '@/components/AlertView';
import CellHeader from '@/components/CellHeader';
import CertImagePicker from '@/components/CertImagePicker';
import { compressImage } from '@/utils';
import * as services from '@/services';

export default {
  name: 'ReportCertRepair',
  components: {
    AlertView,
    PageStatus,
    CellHeader,
    CertImagePicker,
  },

  data() {
    return {
      loading: true,
      submiting: false,
      docDetail: {},
    };
  },

  created() {
    this.fetchData();
  },

  computed: {
    alertConfigNames() {
      const docConfigs = this.docDetail.docConfigs || [];
      return docConfigs.map(config => config.imageNickName).join('、');
    },
  },

  methods: {
    fetchData() {
      const { reportNo, docSerNo } = this.$route.query;
      services.getCarDocDetail(reportNo, docSerNo).then(res => {
        const { status } = res.data;
        if (status === '1') {
          // 1 未上传
          this.docDetail = res.data;
        } else {
          // 2 已上传
          // 3 其他情况 跳转失效
          const query = { type: status === '2' ? 'success' : 'failure' };
          this.$router.replace({ path: '/report-cert-result', query });
        }
        this.loading = false;
      });
    },

    onUpdateImage(value) {
      const { images, imageTag } = value;
      const { reportNo, docSerNo, makeCom, operatorCode } = this.docDetail;

      const formUpload = { makeCom, operatorCode, docCode: imageTag };
      const options = {
        maxWidth: 2048,
        maxHeight: 2048,
        convertSize: 1024 * 1024,
      };
      const uploadTask = imageData => {
        return compressImage(imageData.file, options)
          .then(file =>
            services.uploadCarDocImage(reportNo, docSerNo, {
              ...formUpload,
              file,
            }),
          )
          .then(res => res.data || Promise.reject('Upload Failed'))
          .catch(error => ({
            ...imageData,
            status: 'failed',
            message: '上传失败',
          }));
      };

      return Promise.all(images.map(uploadTask));
    },

    onSubmit() {
      const { reportNo, docSerNo, docConfigs } = this.docDetail;

      const errorItem = docConfigs.find(
        config => config.imageMinQuantity > config.uploadedList.length,
      );
      if (errorItem) {
        const { imageNickName, imageMinQuantity } = errorItem;
        Toast.fail(`${imageNickName}最少需要${imageMinQuantity}张单证`);
        return;
      }

      this.submiting = true;
      services
        .submitCarDocImage(reportNo, docSerNo)
        .then(res => {
          const query = { type: 'success' };
          this.$router.replace({ path: '/report-cert-result', query });
        })
        .finally(() => {
          this.submiting = false;
        });
    },
  },
};
</script>

<style lang="less">
.cert-repair {
  padding-bottom: 84px;

  .van-cell-group + .van-cell-group {
    margin-top: 12px;
  }

  .cert-image-picker {
    margin-top: 8px;
  }

  .item-alert {
    padding: 8px 16px;
  }

  .operate {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    padding: 12px;
    background-color: #fff;
  }
}
</style>
